import {BaseFactory} from "../../../infrastructure/factories/base-factory";
import {FooterResponseApiModel} from "../models/footer.response-api-model";
import {FooterDataSource} from "../models/footer.data-source";

export class FooterFactory extends BaseFactory {
  static injectables = [...BaseFactory.injectables];

  createResponse(apiModel: FooterResponseApiModel) {
    const responseApiModel: FooterResponseApiModel = new FooterResponseApiModel(apiModel);

    return responseApiModel;
  }

  createDomainModel(response: FooterResponseApiModel): FooterDataSource {
    const squadsDataSource: FooterDataSource = new FooterDataSource(response);

    return squadsDataSource;
  }
}
